import {QueryClient} from '@tanstack/react-query';

/**
 * Creates a configured QueryClient instance with MATIC-specific defaults
 * Following TanStack Query v5 best practices
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Data is considered stale after 5 minutes
        staleTime: 5 * 60 * 1000,
        // Data is garbage collected after 10 minutes
        gcTime: 10 * 60 * 1000,
        // Custom retry logic - don't retry client errors (4xx)
        retry(failureCount, error) {
          const status = (error as any)?.status;

          // Don't retry 401 errors - let the BaseApiClient 401 interceptor handle them
          if (status === 401) {
            console.log(
              '🚫 Query: Not retrying 401 error (interceptor handles it)'
            );
            return false;
          }

          // Don't retry client errors - they won't succeed on retry
          // 404 Not Found, 403 Forbidden, 400 Bad Request, etc.
          if (status >= 400 && status < 500) {
            return false;
          }

          // Retry server errors and network errors up to 3 times
          return failureCount < 3;
        },
        // Don't refetch on window focus for better UX
        refetchOnWindowFocus: false,
      },
      mutations: {
        // Custom retry logic for mutations - don't retry client errors
        retry(failureCount, error) {
          const status = (error as any)?.status;

          // Don't retry 401 errors - let the BaseApiClient handle them
          if (status === 401) {
            console.log(
              '🚫 Mutation: Not retrying 401 error (interceptor handles it)'
            );
            return false;
          }

          // Don't retry client errors (4xx)
          if (status >= 400 && status < 500) {
            return false;
          }

          // Retry server errors once
          return failureCount < 1;
        },
      },
    },
  });
}
